import { render, staticRenderFns } from "./FindRecover.vue?vue&type=template&id=52c3eab2"
import script from "./FindRecover.vue?vue&type=script&lang=js"
export * from "./FindRecover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports